import React from "react";

import { SingleSelect, Textfield, PrimaryButton, SecondaryButton } from "widgets";
import {
  SEARCH_SCHOOL_BY_NAME,
  SEARCH_SCHOOL_BY_SCHOOL_CODE,
  SEARCH_SCHOOL_BY_UDISE_CODE,
} from "constants/schoolConstants";
import {
  getSchoolSearchError,
  isSchoolSearchEnabled,
} from "helpers/schoolUtils";

import styles from "./SearchSchools.module.scss";

const searchSchoolByOptions = [
  { value: SEARCH_SCHOOL_BY_UDISE_CODE, label: "UDISE Code" },
  { value: SEARCH_SCHOOL_BY_SCHOOL_CODE, label: "School Code" },
  { value: SEARCH_SCHOOL_BY_NAME, label: "School Name" },
];

const getSearchTermLabel = (searchSchoolBy) => {
  if (searchSchoolBy === SEARCH_SCHOOL_BY_SCHOOL_CODE) {
    return "Enter school code";
  }
  if (searchSchoolBy === SEARCH_SCHOOL_BY_UDISE_CODE) {
    return "Enter UDISE code";
  }
  return "Enter school name";
};

const SearchSchools = (props) => {
  const {
    searchSchoolBy,
    setSearchSchoolBy,
    searchValue,
    setSearchValue,
    handleOnClickSearchButton,
    isLoading,
    handleOnClickClearButton,
  } = props;
  const searchError = getSchoolSearchError(searchSchoolBy, searchValue);

  const handleSearchByChange = (event) => {
    setSearchSchoolBy(event.target.value);
    setSearchValue("");
  };

  return (
    <div className={styles.searchTypeContainer}>
      <div className={styles.searchByField}>
        <SingleSelect
          tag="Search By"
          menuItems={searchSchoolByOptions}
          value={searchSchoolBy}
          handleChange={handleSearchByChange}
        />
      </div>
      <div className={styles.searchTermField}>
        <Textfield
          label={getSearchTermLabel(searchSchoolBy)}
          value={searchValue}
          handleOnChange={(event) => setSearchValue(event.target.value)}
          error={Boolean(searchError)}
          helperText={searchError}
        />
      </div>
      <div className={styles.searchActions}>
        <PrimaryButton
          onClick={handleOnClickSearchButton}
          disabled={!isSchoolSearchEnabled(searchSchoolBy, searchValue) || isLoading}
        >
          {isLoading ? "Searching..." : "Search"}
        </PrimaryButton>
        <SecondaryButton onClick={handleOnClickClearButton}>Clear</SecondaryButton>
      </div>
    </div>
  );
};

export default SearchSchools;
